document.addEventListener("DOMContentLoaded", (() => {
  const reviews = document.getElementById('ProductReviews');
  const reviewsHeadSelector = '#reviews-head';
  const trustpilotLogosSrc = reviews.dataset.logo;

  const trustpilotLogo = `<img class='trustpilot-logo' alt='Trustpilot' width='146' height='36' src='${trustpilotLogosSrc}'>`
  
  
  AppearenceObserver.appear(reviewsHeadSelector).then(section => {
    trustpilotLogo && section.insertAdjacentHTML('afterbegin', trustpilotLogo);
  });
  
}));
